import { render, staticRenderFns } from "./uploadImagesBtn.vue?vue&type=template&id=cfbdb654&scoped=true"
import script from "./uploadImagesBtn.vue?vue&type=script&lang=js"
export * from "./uploadImagesBtn.vue?vue&type=script&lang=js"
import style0 from "./uploadImagesBtn.vue?vue&type=style&index=0&id=cfbdb654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbdb654",
  null
  
)

export default component.exports